export function Button({ children, className = '', variant = '', ...props }) {
  const base = 'px-4 py-2 rounded-xl border';
  const style = variant === 'outline' ? 'border-gray-400 text-gray-700' : 'bg-blue-500 text-white border-blue-500';
  return <button className={`${base} ${style} ${className}`} {...props}>{children}</button>;
}
